module.exports = __webpack_public_path__ + "img/e70f1f6.png";